import {
  GiftCardDef,
  GiftCardDefFormData,
  GiftCardDoc,
  GiftCarDocList,
  GiftCardStatus,
  GiftCardType,
  GiftCardTypeFormData,
} from "../types/giftCard";
import { get, post } from "./fetch.core";

export interface GiftCardListFilter {
  paging: {
    page: number;
    size: number;
  };
  userIds: string[];
}

async function create(data: GiftCardDefFormData) {
  sanitizeInput(data);
  const rst = await post("/admin/giftCardDef/create", data);
}

export async function loadGiftCardDefs() {
  const rst = await get<GiftCardDef[]>("/admin/giftCardDef/list");
  return rst.data;
}

async function edit(data: GiftCardDefFormData, id: string) {
  sanitizeInput(data);
  const rst = await post(`/admin/giftCardDef/edit?giftCardDefId=${id}`, data);
}

async function getOne(id: string) {
  const rst = await get<GiftCardDef>(`/admin/giftCardDef/get?giftCardDefId=${id}`);
  return rst.data;
}

async function listTypes() {
  const rst = await get<GiftCardType[]>("/admin/giftCardType/list");
  return rst.data;
}

async function createType(data: GiftCardTypeFormData) {
  const rst = await post<GiftCardType>("/admin/giftCardType/create", data);
  return rst.data;
}

async function getType(id: string) {
  const rst = await get<GiftCardType>(`/admin/giftCardType/get?id=${id}`);
  return rst.data;
}

async function editType(data: GiftCardTypeFormData, id: string) {
  const rst = await post(`/admin/giftCardType/edit?id=${id}`, data);
  return rst.data;
}

function sanitizeInput(data: GiftCardDefFormData) {
  if ((data.price as any) === "") (data as any).price = null;
  if ((data.eshopPrice as any) === "") (data as any).eshopPrice = null;
  if ((data.defaultRetailPrice as any) === "") (data as any).defaultRetailPrice = null;
  data.retailPrices = (data as any).retailPrices.map((rs) => ({
    retailShopId: rs.retailShopId,
    price: rs.price === "" ? null : rs.price,
  }));

  if ((data.startDate as any) === "") {
    delete (data as any).startDate;
  }

  if (data.eligibility) {
    if ((data.eligibility.orderOverAmt as any) === "") {
      delete (data.eligibility as any).orderOverAmt;
    }

    if (!data.eligibility.includeMembershipIds || data.eligibility.includeMembershipIds.length === 0) {
      delete (data.eligibility as any).includeMembershipIds;
    }

    if (!data.eligibility.excludeMembershipIds || data.eligibility.excludeMembershipIds.length === 0) {
      delete (data.eligibility as any).excludeMembershipIds;
    }

    if (!data.eligibility.placementRestriction?.type || data.eligibility.placementRestriction.type === "none") {
      delete (data.eligibility as any).placementRestriction;
    } else {
      if (data.eligibility.placementRestriction.restrictToEshop === false) {
        delete (data.eligibility.placementRestriction as any).restrictToEshop;
      }
      if (!data.eligibility.placementRestriction.restrictToRetailIds || data.eligibility.placementRestriction.restrictToRetailIds.length === 0) {
        delete (data.eligibility.placementRestriction as any).restrictToRetailIds;
      }
    }
  }
}

export async function listDocs(customerId?: string) {
  const rst = await get<GiftCardDoc[]>(`/admin/giftCardDoc/list?userId=${customerId}`);
  return rst.data;
}

// async function listGiftCardByCodeType(customerId?: string, giftCardTypeCodes?: string[]) {
//   const rst = await post<GiftCardDoc[]>(`/admin/giftCardDoc/listByCodeType?userId=${customerId}`, {
//     giftCardTypeCodes : giftCardTypeCodes
//   });
//   return rst.data;
// }

async function listGiftCardByCodeType(filter: GiftCardListFilter, giftCardTypeCodes: string[]) {
  const rst = await post<GiftCarDocList>("/admin/giftCardDoc/listByCodeType", {
    giftCardTypeCodes: giftCardTypeCodes,
    paging: filter.paging,
    userIds: filter.userIds,
  });
  return rst.data;
}

export async function issueManualGiftCard(data: { giftCardDefId: string; userId: string; value: number }) {
  const rst = await post<GiftCardDoc>("/admin/giftCardDoc/manualIssueGiftCard", data);
  return rst.data;
}

export async function getOneGiftCard(id: string) {
  const rst = await get<GiftCardDoc>(`/admin/giftCardDoc/get?id=${id}`);
  return rst.data;
}

export async function editOneGiftCard(data: { id: string; value: number; balance: number; status: GiftCardStatus }) {
  const rst = await post<GiftCardDoc>("/admin/giftCardDoc/edit", data);
  return rst.data;
}

const giftCardCore = {
  loadGiftCardDefs,
  create,
  edit,
  getOne,
  listDocs,
  listTypes,
  createType,
  getType,
  editType,
  listGiftCardByCodeType,
};

export default giftCardCore;
